import { j as e } from "./AccesRecoveryIcon-CUPieIxT.js";
const t = () => /* @__PURE__ */ e.jsxs("svg", { viewBox: "0 0 56 56", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ e.jsx("g", { clipPath: "url(#clip0_14423_202166)", children: /* @__PURE__ */ e.jsx(
    "path",
    {
      clipPath: "evenodd",
      clipRule: "evenodd",
      d: "M31.3639 30.4203V30.4169C31.1714 30.4309 30.1791 30.4903 27.9654 30.4903C26.1979 30.4903 24.9536 30.4379 24.5161 30.4169V30.4221C17.7121 30.1229 12.6336 28.9381 12.6336 27.5206C12.6336 26.1048 17.7121 24.9201 24.5161 24.6156V29.2426C24.9606 29.2741 26.2346 29.3493 27.9951 29.3493C30.1074 29.3493 31.1661 29.2618 31.3639 29.2443V24.6191C38.1539 24.9218 43.2201 26.1066 43.2201 27.5206C43.2201 28.9381 38.1539 30.1193 31.3639 30.4203ZM31.3639 24.1379V19.9974H40.8384V13.6833H15.0416V19.9974H24.5161V24.1361C16.8161 24.4896 11.0254 26.0156 11.0254 27.8426C11.0254 29.6696 16.8161 31.1938 24.5161 31.5491V44.8176H31.3639V31.5456C39.0516 31.1921 44.8284 29.6678 44.8284 27.8426C44.8284 26.0173 39.0516 24.4931 31.3639 24.1379Z",
      fill: "currentColor"
    }
  ) }),
  /* @__PURE__ */ e.jsx("rect", { x: "1", y: "1", width: "54", height: "54", rx: "27", stroke: "currentColor", strokeWidth: "2" }),
  /* @__PURE__ */ e.jsx("defs", { children: /* @__PURE__ */ e.jsx("clipPath", { id: "clip0_14423_202166", children: /* @__PURE__ */ e.jsx("rect", { width: "56", height: "56", rx: "28", fill: "white" }) }) })
] });
export {
  t as U
};
